// Path: src\Components\LeaderBoard\Leaderboardbox.jsx
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import Leaderboardusericon from "../../images/leaderboardusericon.png";
import PremiumImg from "../../assets/images/premiumtransparent.png";
import { todayLeaderBoard } from "../../api/leaderboard.api";
import User from "../../assets/images/user-icon.svg";
import { url } from "../../config/url";
import ListLoader from "../Common/ListLoader";
import { useNavigate } from "react-router";
const LeaderBoardbox = ({ style, style1, type }) => {
  const navigate = useNavigate();
  const [leaderboardList, setLeaderboardList] = useState([]);
  const [leaderboardRank1, setLeaderboardRank1] = useState({});
  const [leaderboardRank2, setLeaderboardRank2] = useState({});
  const [leaderboardRank3, setLeaderboardRank3] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [recordPerPage, setRecordPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (currentPage <= totalPages) loadMore();
  }, [currentPage]);

  const loadMore = async () => {
    setLoading(true);
    fetchLeaderboard();
  };

  const observer = useRef();
  const lastPostElementRef = useCallback(
    async (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          setCurrentPage((prevPage) => prevPage + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading]
  );

  const fetchLeaderboard = async () => {
    try {
      let data = {
        pagination: {
          pageNo: currentPage,
          recordPerPage: recordPerPage,
          sortBy: "date",
          sortDirection: "desc",
        },
      };

      const res = await todayLeaderBoard(data);
      setLoading(false);
      if (res?.success && res?.list) {
        if (currentPage == 1) {
          setLeaderboardList(res?.list);
          let filterDataRank1 = res?.list?.filter(
            (item) => item?.rank == 1
          )?.[0];
          if (filterDataRank1) {
            setLeaderboardRank1(filterDataRank1);
          }
          let filterDataRank2 = res?.list?.filter(
            (item) => item?.rank == 2
          )?.[0];
          if (filterDataRank2) {
            setLeaderboardRank2(filterDataRank2);
          }
          let filterDataRank3 = res?.list?.filter(
            (item) => item?.rank == 3
          )?.[0];
          if (filterDataRank3) {
            setLeaderboardRank3(filterDataRank3);
          }
        } else {
          setLeaderboardList([...leaderboardList, ...res?.list]);
        }
        setTotalPages(res?.totalPages);
      } else {
        setLeaderboardList([]);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <>
      {/* {loading && <div className='w-100 d-flex justify-content-center'> <ListLoader/></div>} */}
      {leaderboardList && leaderboardList?.length > 0 ? (
        <div className="leaderboard-main-box">
          <div className="leaderboard-inner-wrapper" style={style}>
            <div className="leaderboard-maindiv">
              <div className="leaderboard-background-circle-line"></div>
              <div className="leaderboard-background-circle-line circle2"></div>
            </div>
          </div>
          <div>
            <div className="leaderboard-top-three-box-wrapper" style={style}>
              <div className="row leaderboard-top-three-box-main">
                <div className="col-4 leaderboard-top-three-profile-1">
                  {leaderboardRank2 && leaderboardRank2?.rank && (
                    <>
                      <div className="leaderboard-player-detail">
                        <span className="playericon">
                          {leaderboardRank2?.level ? (
                            <img
                              className="leaderboard-profile-icon-1"
                              src={url?.IMAGE_URL + leaderboardRank2?.level}
                              alt="user icon"
                            />
                          ) : (
                            <img
                              className="leaderboard-profile-icon-1"
                              src={User}
                              alt="user icon"
                            />
                          )}
                        </span>
                        <div className="leaderboard-player-name">
                        {leaderboardRank2?.gamerjiName?.length > 6 ? (
                                      <marquee>
                                        {leaderboardRank2?.gamerjiName}
                                      </marquee>
                                    ) : (
                                      leaderboardRank2?.gamerjiName
                                    )}
                          {/* {leaderboardRank2?.gamerjiName} */}
                        </div>
                        <div className="leaderboard-points-rectangle leaderboard-second">
                          {leaderboardRank2?.points || 0} pts
                        </div>
                      </div>

                      <div className="leaderboard-rank-svg second-rank-svg">
                        <svg
                          className="leaderboard-box-svg"
                          xmlns="http://www.w3.org/2000/svg"
                          width="104"
                          height="138"
                          viewBox="0 0 104 138"
                          fill="none"
                        >
                          <rect
                            y="16"
                            width="104"
                            height="122"
                            fill="#2F3043"
                          />
                          <path
                            d="M14.1818 0H104V16H0L14.1818 0Z"
                            fill="#9F6693"
                          />
                        </svg>
                        <div className="playerrankleaderboard">
                          {leaderboardRank2?.rank || 0}
                        </div>
                      </div>
                    </>
                  )}
                </div>
                <div className="col-4 leaderboard-top-three-profile-1">
                  {leaderboardRank1 && leaderboardRank1?.rank && (
                    <>
                      <div className="leaderboard-player-detail leaderboard-firstplayer-basicdetails mb-10">
                        <span className="playericon">
                          {leaderboardRank1?.level ? (
                            <img
                              className="leaderboard-profile-icon-1"
                              src={url?.IMAGE_URL + leaderboardRank1?.level}
                              alt="user icon"
                            />
                          ) : (
                            <img
                              className="leaderboard-profile-icon-1"
                              src={User}
                              alt="user icon"
                            />
                          )}
                        </span>
                        <div className="leaderboard-player-name">
                        {leaderboardRank1?.gamerjiName?.length > 6 ? (
                                      <marquee>
                                        {leaderboardRank1?.gamerjiName}
                                      </marquee>
                                    ) : (
                                      leaderboardRank1?.gamerjiName
                                    )}
                          {/* {leaderboardRank1?.gamerjiName} */}
                        </div>
                        <div className="leaderboard-points-rectangle leaderboard-first">
                          {leaderboardRank1?.points || 0} pts
                        </div>
                      </div>

                      <div className="leaderboard-rank-svg first-rank-svg">
                        <svg
                          className="leaderboard-box-svg-firstrank"
                          xmlns="http://www.w3.org/2000/svg"
                          width="110"
                          height="192"
                          viewBox="0 0 110 192"
                          fill="none"
                        >
                          <rect
                            y="14"
                            width="110"
                            height="178"
                            fill="url(#paint0_linear_2842_10707)"
                          />
                          <path
                            d="M16 0H94L110 14.2901H0L16 0Z"
                            fill="#9F6693"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear_2842_10707"
                              x1="55"
                              y1="14"
                              x2="55"
                              y2="139.179"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stop-color="#A1819B" />
                              <stop offset="1" stop-color="#AFA3AC" />
                            </linearGradient>
                          </defs>
                        </svg>
                        <div className="playerrankleaderboard-third-first">
                          {leaderboardRank1?.rank || 0}
                        </div>
                      </div>
                    </>
                  )}
                </div>
                <div className="col-4 leaderboard-top-three-profile-1">
                  {leaderboardRank3 && leaderboardRank3?.rank && (
                    <>
                      <div className="leaderboard-player-detail margin-third-player">
                        <span className="playericon">
                          {leaderboardRank3?.level ? (
                            <img
                              className="leaderboard-profile-icon-1"
                              src={url?.IMAGE_URL + leaderboardRank3?.level}
                              alt="user icon"
                            />
                          ) : (
                            <img
                              className="leaderboard-profile-icon-1"
                              src={User}
                              alt="user icon"
                            />
                          )}
                        </span>
                        <div className="leaderboard-player-name">
                        {leaderboardRank3?.gamerjiName?.length > 6 ? (
                                      <marquee>
                                        {leaderboardRank3?.gamerjiName}
                                      </marquee>
                                    ) : (
                                      leaderboardRank3?.gamerjiName
                                    )}
                          {/* {leaderboardRank3?.gamerjiName} */}
                        </div>
                        <div className="leaderboard-points-rectangle leaderboard-third">
                          {leaderboardRank3?.points || 0} pts
                        </div>
                      </div>
                      <div className="leaderboard-rank-svg third-rank-svg">
                        <svg
                          className="leaderboard-player-three-svg"
                          xmlns="http://www.w3.org/2000/svg"
                          width="104"
                          height="97"
                          viewBox="0 0 104 97"
                          fill="none"
                        >
                          <rect y="16" width="104" height="81" fill="#2F3043" />
                          <path d="M0 0H88.8727L104 16H0L0 0Z" fill="#9F6693" />
                        </svg>
                        <div className="playerrankleaderboard-third">
                          {leaderboardRank3?.rank || 0}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="leaderboard-list-box" style={style1}>
              {/* <div className="leaderboard-list-overlay"> */}

              <div className="leaderboardtop-ellipse-1">
                <svg
                  width="100%"
                  height="210%"
                  viewBox="0 0 359 60"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 45.2776C0 27.6045 14.3269 13.2776 32 13.2776H89.75H134.625H140.548C150.908 13.2776 160.247 7.29803 169.47 2.57906C172.441 1.0591 175.828 0 179.5 0C183.172 0 186.559 1.0591 189.53 2.57906C198.753 7.29803 208.092 13.2776 218.452 13.2776H224.375H269.25H327C344.673 13.2776 359 27.6045 359 45.2776V60H179.5H0V45.2776Z"
                    fill="#2F3043"
                  />
                </svg>
                {/* <div className="leaderboard-circle"></div> */}
              </div>
              <div
                className="leaderboard-list-container"
                // style={{ overflow: "hidden" }}
              >
                {/* header */}
                <div
                  className="leaderboard-list-sticky-header d-flex"
                  style={{ zIndex: "9999" }}
                >
                  {/* <div className="leaderboard-table-heading"> */}
                  <div className="rank border-right-white">
                    {t("leaderboard.rank")}
                  </div>
                  <div className="team-name border-right-white">
                    {t("leaderboard.team_name")}
                  </div>
                  <div className="rank points">{t("leaderboard.points")}</div>
                  {/* </div> */}
                </div>
                <div
                  className="list-leaderboard-scroll"
                  // style={{ overflowY: "auto" }}
                >
                  {leaderboardList.map((item, index) => {
                    return (
                      <div
                        className="leaderboard-table-dataa"
                        key={index}
                        ref={
                          leaderboardList?.length === index + 1
                            ? lastPostElementRef
                            : null
                        }
                      >
                        <div className={`leaderboard-rank-table-list ${Number(item?.rank||0)===1 ?'leaderboard-first':Number(item?.rank||0)===2 ?'leaderboard-second' : Number(item?.rank||0)===3 ?'leaderboard-third' :'leaderboard-default'}`}>
                          <span>#{item?.rank || 0}</span>
                        </div>
                        <div
                          className={`${
                            item?.isPremium
                              ? "leaderboard-user-rank-list-container"
                              : "leaderboard-user-rank-list"
                          }`}
                          onClick={() => navigate("/user-profile/" + item?._id)}
                        >
                          {item?.level ? (
                            <img
                              className="leaderboard-icon-list"
                              src={url?.IMAGE_URL + item?.level}
                              alt="user icon"
                            />
                          ) : (
                            <img
                              className="leaderboard-icon-list"
                              src={User}
                              alt="user icon"
                            />
                          )}
                          <div className="leaderboard-inner-details-wrap row">
                            <div className="leaderboard-player-info col-7">
                              <div className="player-name">
                              
                                    {item?.gamerjiName?.length > 10 ? (
                                      <marquee>
                                        {item?.gamerjiName}
                                      </marquee>
                                    ) : (
                                      item?.gamerjiName
                                    )}
                                {/* {item?.gamerjiName} */}
                              </div>
                              <div className="player-level">
                                level {item?.userLevel || 0}
                              </div>
                            </div>
                            {item?.isPremium && (
                              <div className="commom-dflex col-3">
                                <img
                                  className="leaderboard-premium-icon"
                                  src={PremiumImg}
                                ></img>
                              </div>
                            )}
                            <div className="leaderboard-points col-2">
                              {item?.points || 0}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              {/* </div> */}
            </div>
          </div>
        </div>
      ) : (
        !loading && (
          <div className="w-100 d-flex justify-content-center">
            <div className="no-record-found-center">
              {t("common.no_data_found")}
            </div>
          </div>
        )
      )}
      {loading && (
        <div className="w-100 d-flex justify-content-center">
          {" "}
          <ListLoader />
        </div>
      )}
    </>
  );
};

export default LeaderBoardbox;
